<template>
    <div>
        <v-radio-group
                v-model="typeFilter"
                mandatory
                row
                dense
        >
            <v-radio
                    v-for="type in types" :key="type.value"
                    :label="type.label"
                    :value="type.value"
            />


        </v-radio-group>
        <v-autocomplete
                v-model=selectedTrainingClass
                :items="trainingClasses"
                :loading="this.$apollo.queries.trainingClasses.loading"
                :search-input.sync="search"
                color="white"
                :item-text="itemTitle"
                item-value="id"
                placeholder="Start typing to Search"
                label="Find Training Class"
                return-object
                no-filter
                prepend-icon="mdi-database-search"
                @change="emitSelected"
                :error-messages="errorMessages"
        >

            <template v-slot:item="data">
                <template v-if="data.item">
                        <v-list-item-avatar v-if="data.item.iconUrl" >
                            <img :src="data.item.iconUrl">
                        </v-list-item-avatar>
                        <v-list-item-avatar v-else color="grey"/>
                        <v-list-item-content>
                            <v-list-item-title>{{data.item.company}} - {{data.item.title}}</v-list-item-title>
                            <v-list-item-subtitle>{{data.item.firstSessionDate | formatDate}} - (CL-{{data.item.id}})</v-list-item-subtitle>
                        </v-list-item-content>
                </template>
            </template>

            <template v-slot:selection="data">
                <template v-if="data.item">
                    <v-list>
                        <v-list-item>
                        <v-list-item-avatar v-if="data.item.iconUrl" >
                            <img :src="data.item.iconUrl">
                        </v-list-item-avatar>
                        <v-list-item-avatar v-else color="grey"/>
                        <v-list-item-content>
                            <v-list-item-title>{{data.item.company}} - {{data.item.title}}</v-list-item-title>
                            <v-list-item-subtitle>{{data.item.firstSessionDate | formatDate}} - (CL-{{data.item.id}})</v-list-item-subtitle>
                        </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </template>
            </template>
        </v-autocomplete>
    </div>
</template>

<script>
    import TRAINING_CLASS_LIST_FUTURE from "../../graphql/TrainingClass/ListFuture.gql"

    export default {
        data() {
            return {
                selectedTrainingClass: { id: this.value },
                currentTrainingClass: {},
                search: null,
                types: [
                    {label: 'All', value: 'all'},
                    {label: 'Public', value: 'public'},
                    {label: 'Private', value: 'private'},
                ],
                typeFilter: this.defaultTypeFilter,
            }
        },
        props: {
            value: {
                type: [String],
                default: ""
            },
            future: {
                type: Boolean,
                default: true
            },
            showTypeFilter: {
                type: Boolean,
                default: true
            },
            defaultTypeFilter: {
                type: String,
                default: 'all'
            },
            errorMessages: {
                type: Array
            },
            returnObject: {
                type: Boolean,
                default: false
            }
        },
        apollo: {
            trainingClasses: {
                query: TRAINING_CLASS_LIST_FUTURE,
                variables() {

                    let vars = {
                        orderBy: {field: 'COMPANY', order:'ASC'},
                    }

                    let ands = []

                    if(this.typeFilter !== 'all') {
                        let columnName = ''

                        if(this.typeFilter === 'public'){
                            columnName = 'CLASS_SCHEDULED'
                        }

                        if(this.typeFilter === 'private'){
                            columnName = 'CLASS_SINGLE_C_O'
                        }

                        ands.push({column: columnName, operator: 'EQ', value: 1})
                    }

                    if(this.search){
                        ands.push({
                                OR: [
                                    {column: 'CLASS_TITLE', operator: 'LIKE', value: '%' + this.search + '%'},
                                    {column: 'COMPANY', operator: 'LIKE', value: '%' + this.search + '%'},
                                    {column: 'CLASS_I_D', operator: 'LIKE', value: '%' + this.search + '%' },
                                ]
                            })
                    }

                    vars.where = {
                        AND: ands
                    }

                    return vars
                },
                update: data => data.futureTrainingClasses

            },
        },
        methods: {
            itemTitle(trainingClass) {
                return trainingClass.company + ' - ' +  trainingClass.title + ' (CL-' + trainingClass.id + ')'
            },
            emitSelected(trainingClass) {
                if(this.returnObject) {
                    this.$emit('input', trainingClass)
                }else{
                    this.$emit('input', trainingClass.id)
                }


                this.$emit('selected', trainingClass)
            }
        },
    }
</script>

<style scoped>

</style>